import styles from './ProductsCarousel.module.scss';
import SwiperCustom from '../SwiperCustom/SwiperCustom';
import { SwiperSlide } from 'swiper/react';
import React, { useContext, useEffect, useState } from 'react';
import Product from './Product';
import { ModalProvider } from '../Modal/modalContext';
import { generateKey, sanitizeType } from '../../functions';
import { DataContext } from '../../views/pages/Root';
import cloneDeep from 'lodash/cloneDeep';

const ProductsCarousel = ({ productsList, type }) => {
  const data = useContext(DataContext);
  const filteredSet = [...new Set(productsList)];
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect((_) => {
    setProducts(data?.products);
  }, []);

  useEffect(
    (_) => {
      if (!!products?.length) {
        let sumPrice = 0;
        const newItems = [];
        filteredSet.forEach((productID) => {
          const isProductObject = productID.hasOwnProperty('product');
          const finalProduct = cloneDeep(products.find((prod) => prod.id == (isProductObject ? productID.product : productID)));
          if (!!finalProduct?.name) {
            if (isProductObject) {
              finalProduct.activeBorder = !!productID?.border;
            }
            newItems.push(finalProduct);
            // const regularPrice = !!finalProduct?.regularPrice ? finalProduct.regularPrice : finalProduct.salePrice;
            // const salePrice = !!finalProduct?.salePrice && finalProduct.salePrice != regularPrice ? finalProduct.salePrice : null;
            //
            // console.log("sadadd", sumPrice, salePrice, regularPrice, !!salePrice ? salePrice : !!regularPrice ? regularPrice : 0);
            //
            // sumPrice += !!salePrice ? salePrice : !!regularPrice ? regularPrice : 0;
          }
        });
        // onProductsPriceChange(sumPrice);
        // if (!!onProductsPriceChange) {
        //   sumPrice = sumPrice.toFixed(2);
        //   if(!!sumPrice?.length && sumPrice.length > 3 && sumPrice.charAt(sumPrice.length - 1) == 0 && sumPrice.charAt(sumPrice.length - 2) == 0){
        //     sumPrice=sumPrice.slice(0, -3);
        //   }
        //   onProductsPriceChange(sumPrice);
        // }
        setFilteredProducts(newItems);
      }
    },
    [products, productsList]
  );

  return (
    !!filteredProducts && (
      <SwiperCustom
        className={`${styles.swiper} ${sanitizeType(type, styles)}`}
        animationData={{ animation: 'fade-up', animationDuration: '1000', animationEasing: 'easy-in-out' }}
        type={type}
        breakpoints={
          type == 'productSubcategory' || type?.includes('productSubcategory')
            ? {
                390: {
                  slidesPerView: 1.3,
                },
                640: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 3.5,
                },
                1600: {
                  slidesPerView: 4.5,
                },
              }
            : null
        }
      >
        {filteredProducts.map((product) => {
          return !!product?.name ? (
            <SwiperSlide className={styles.swiperSlide} key={generateKey()}>
              <ModalProvider>
                <Product product={product} />
              </ModalProvider>
            </SwiperSlide>
          ) : null;
        })}
      </SwiperCustom>
    )
  );
};
export default ProductsCarousel;
